"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSubSchemaOptions = exports.defaultSchemaOptions = void 0;
exports.defaultSchemaOptions = {};
exports.defaultSubSchemaOptions = {};
//# sourceMappingURL=default-schema-options.js.map